import React from "react";
import "./CredMobile.css";
import collaborate from "../../assets/cred/collaborate.gif";
import productive from "../../assets/cred/productive.gif";
import underoneroof from "../../assets/cred/underoneroof.gif";
import corner from "../../assets/corner.png";
import cornerTR from "../../assets/cornerTR.png";
import cornerBR from "../../assets/cornerBR.png";
import cornerBL from "../../assets/cornerBL.png";
import vector from "../../assets/cred/vector.png";

const CredMobile = () => {
  return (
    <>
      <div className="section credMSection">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-sm-12 col-12 cred-image-col">
              <div className="img-container">
                <img src={collaborate} alt="" className="gif-container" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 col-12">
              <div className="cred-scrollable mobilecreddescription" id="cred-1">
                <img src={corner} alt="" id="topleft" />
                <img src={cornerTR} alt="" id="topright" />
                <img src={cornerBR} alt="" id="bottomright" />
                <img src={cornerBL} alt="" id="bottomleft" />
                <div>
                  <p className="strikethrough-text">
                    zoom fatigue, with boxed video tiles
                  </p>
                  <div className="cred-heading-container">
                    <p className="cred-heading">
                      efficient, rewarding collaboration
                    </p>
                    <img src={vector} alt="" className="arrow" />
                  </div>
                  <p className="cred-descriptionbox">
                    spontaneous real-time communication{" "}
                  </p>
                  <button className="tryyourself-cred">try yourself >>></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section credMSection">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-12 cred-image-col">
              <div className="img-container">
                <img src={productive} alt="" className="gif-container" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 col-12">
              <div className="cred-scrollable mobilecreddescription" id="cred-1">
                <img src={corner} alt="" id="topleft" />
                <img src={cornerTR} alt="" id="topright" />
                <img src={cornerBR} alt="" id="bottomright" />
                <img src={cornerBL} alt="" id="bottomleft" />
                <div>
                  <p className="strikethrough-text">
                    broken into asynchronous silos
                  </p>
                  <div className="cred-heading-container">
                    <p className="cred-heading">
                      entire commune sits under one roof
                    </p>
                    <img src={vector} alt="" className="arrow" />
                  </div>
                  <p className="cred-descriptionbox">
                    build a strong culture with shared experiences
                  </p>
                  <button className="tryyourself-cred">try yourself >>></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section credMSection">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-12 cred-image-col">
              <div className="img-container">
                <img src={underoneroof} alt="" className="gif-container" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 col-12">
              <div className="cred-scrollable mobilecreddescription" id="cred-1">
                <img src={corner} alt="" id="topleft" />
                <img src={cornerTR} alt="" id="topright" />
                <img src={cornerBR} alt="" id="bottomright" />
                <img src={cornerBL} alt="" id="bottomleft" />
                <div>
                  <p className="strikethrough-text">
                    lack of effective engagement
                  </p>
                  <div className="cred-heading-container">
                    <p className="cred-heading">
                      mimic real-like social dynamics
                    </p>
                    <img src={vector} alt="" className="arrow" />
                  </div>
                  <p className="cred-descriptionbox">
                    real-like engagement & networking experience
                  </p>
                  <button className="tryyourself-cred">try yourself >>></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    // <div className="container-fluid cred-outer-containerM">
    //   <div className="container cred-inner-containerM">
    //     <div className="row">
    //       <div className="col-md-6 col-sm-12 col-12 cred-image-col">
    //         <div className="img-container">
    //           <img src={collaborate} alt="" className="gif-container" />
    //         </div>
    //       </div>
    //       <div className="col-md-6 col-sm-12 col-12">
    //         <div className="cred-scrollable mobilecreddescription" id="cred-1">
    //           <img src={corner} alt="" id="topleft" />
    //           <img src={cornerTR} alt="" id="topright" />
    //           <img src={cornerBR} alt="" id="bottomright" />
    //           <img src={cornerBL} alt="" id="bottomleft" />
    //           <div>
    //             <p className="strikethrough-text">
    //               zoom fatigue, with boxed video tiles
    //             </p>
    //             <div className="cred-heading-container">
    //               <p className="cred-heading">
    //                 efficient, rewarding collaboration
    //               </p>
    //               <img src={vector} alt="" className="arrow" />
    //             </div>
    //             <p className="cred-descriptionbox">
    //               spontaneous real-time communication{" "}
    //             </p>
    //             <button className="tryyourself-cred">try yourself >>></button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   <div className="row">
    //   <div className="col-md-6 col-sm-12 col-12 cred-image-col">
    //     <div className="img-container">
    //       <img src={productive} alt="" className="gif-container" />
    //     </div>
    //   </div>
    //   <div className="col-md-6 col-sm-12 col-12">
    //     <div className="cred-scrollable mobilecreddescription" id="cred-1">
    //       <img src={corner} alt="" id="topleft" />
    //       <img src={cornerTR} alt="" id="topright" />
    //       <img src={cornerBR} alt="" id="bottomright" />
    //       <img src={cornerBL} alt="" id="bottomleft" />
    //       <div>
    //         <p className="strikethrough-text">
    //           broken into asynchronous silos
    //         </p>
    //         <div className="cred-heading-container">
    //           <p className="cred-heading">
    //             entire commune sits under one roof
    //           </p>
    //           <img src={vector} alt="" className="arrow" />
    //         </div>
    //         <p className="cred-descriptionbox">
    //           build a strong culture with shared experiences
    //         </p>
    //         <button className="tryyourself-cred">try yourself >>></button>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    //     <div className="row">
    //       <div className="col-md-6 col-sm-12 col-12 cred-image-col">
    //         <div className="img-container">
    //           <img src={underoneroof} alt="" className="gif-container" />
    //         </div>
    //       </div>
    //       <div className="col-md-6 col-sm-12 col-12">
    //         <div className="cred-scrollable mobilecreddescription" id="cred-1">
    //           <img src={corner} alt="" id="topleft" />
    //           <img src={cornerTR} alt="" id="topright" />
    //           <img src={cornerBR} alt="" id="bottomright" />
    //           <img src={cornerBL} alt="" id="bottomleft" />
    //           <div>
    //             <p className="strikethrough-text">
    //               lack of effective engagement
    //             </p>
    //             <div className="cred-heading-container">
    //               <p className="cred-heading">
    //                 mimic real-like social dynamics
    //               </p>
    //               <img src={vector} alt="" className="arrow" />
    //             </div>
    //             <p className="cred-descriptionbox">
    //               real-like engagement & networking experience
    //             </p>
    //             <button className="tryyourself-cred">try yourself >>></button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default CredMobile;
